module.exports = __webpack_public_path__ + "img/ep-V-dosis.e12911e7.jpg";